import type { MealBranchStatus } from '@/features/meal/domain/enums/MealBranchStatus'
import type { MealStatus } from '@/features/meal/domain/enums/MealStatus'
import type { DeliveryStatus } from '@/features/order/domain/enums/DeliveryStatus'
import type { LngLatEntity } from '@/shared/entities/LngLatEntity'

export class MealMonitoringEntity {
  id?: string
  mealId?: string
  createdAt?: string
  company?: {
    id?: number
    name?: string | null
    logoUrl?: string | null
    location?: LngLatEntity
    mealTierId?: number
    mealTierName?: string | null
  }
  service?: {
    id?: number
    name?: string | null
  }
  latestDelivery?: {
    createdAt?: string
    updatedAt?: string
    id?: string
    driver?: {
      createdAt?: string
      updatedAt?: string
      id?: number
      workingPhoneNumber?: string | null
      fullName?: string | null
      avatarImagePath?: string | null
    }
    status?: DeliveryStatus
  }
  startAt?: string
  lockAt?: string
  companyPeriodTime?: string
  status?: MealStatus
  statusUpdatedAt?: string
  referenceCode?: string
  hasActiveSearch?: boolean
  mealBranches?: Array<{
    id?: string
    name?: string | null
    status?: MealBranchStatus
    estimatedItemsPreparationTime?: string | null
  }> | null
}
